import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { formatDateDDMMYYYY, formatTimeWAT } from "@/lib/format";
import { toast } from "sonner";
import { Dumbbell, GraduationCap, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export const GuardTraining = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/trainings");
    setItems(r.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const done = async (id) => {
    await api.put(`/trainings/${id}/complete`);
    toast.success("Marked complete — well done");
    load();
  };

  return (
    <div className="space-y-3">
      {items.length === 0 && <div className="text-muted text-center" style={{ fontSize: 13 }}>No sessions scheduled yet.</div>}
      {items.map(t => {
        const isWorkout = t.type === "WORKOUT";
        const Icon = isWorkout ? Dumbbell : GraduationCap;
        const completed = (t.completed_guard_ids || []).includes(user.guard_id);
        return (
          <div key={t.id} className="s-card" data-testid={`gtraining-${t.id}`}>
            <div className="flex items-start gap-3 mb-3">
              <div style={{ width: 40, height: 40, borderRadius: 8,
                            background: isWorkout ? "rgba(201, 168, 76, 0.15)" : "rgba(46,202,200,0.15)",
                            display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon size={20} color={isWorkout ? "#C9A84C" : "#2ECAC8"} />
              </div>
              <div className="flex-1">
                <div style={{ fontSize: 15, color: "#fff" }}>{t.title}</div>
                <div className="text-muted mono" style={{ fontSize: 12, marginTop: 4 }}>
                  {formatDateDDMMYYYY(t.start_at)} · {formatTimeWAT(t.start_at)} → {formatTimeWAT(t.end_at)}
                </div>
                <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>{t.location}</div>
              </div>
            </div>
            {t.description && <div className="text-muted" style={{ fontSize: 13, marginBottom: 12 }}>{t.description}</div>}
            {completed ? (
              <div className="text-success flex items-center gap-2" style={{ fontSize: 13 }}>
                <CheckCircle2 size={14} /> You completed this session
              </div>
            ) : (
              <button onClick={() => done(t.id)} className="btn-outline w-full tap-target" data-testid={`gtrain-done-${t.id}`}>
                Mark complete
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};
